import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import * as S from './styles';

export interface IChatWithUsProps {
  sectionId?: string;
}
import { chatWithUsConfig } from './chatWithUs.config'; 
export const ChatWithUs: React.FC<IChatWithUsProps> = ({ sectionId }) => {

  return (
    <section className="section section-md bg-gray-100 pt-lg-5" id={sectionId}>
      <Container>
        <Row className="justify-content-center mb-5">
          <Col lg={12} className="text-center">
            <S.Title>Chat with us</S.Title>
          </Col>
        </Row>
        <Row className="justify-content-between align-items-center">
          {chatWithUsConfig.contactOptions.map((option, index) => (
            <Col lg={2} key={`chat-with-us-option-${index}`} className="text-center mb-4">
              <div
                className="flex items-center justify-center mx-auto mb-2"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: option.bgColor,
                  overflow: 'hidden',
                  borderRadius: '50%', // Explicitly set to make it circular
                }}
              >
                <img
                  src={option.icon}
                  alt={`${option.title} Icon`}
                  style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }}
                />
              </div>
              <h3 className="text-lg font-semibold text-[#333333] mb-2">{option.title}</h3>
              {option.detail && (
                <S.Description className="text-[#666666] break-words">
                  {option.detail}
                </S.Description>
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

ChatWithUs.defaultProps = {
  sectionId: 'chat-with-us',
};

export default ChatWithUs;